module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-47cde152.png";